import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import injectStyles from 'react-jss'

import { Breadcrumb } from 'react-breadcrumbs'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { Breadcrumbs } from 'Components/Breadcrumbs/index'
import { ClientViewWrapper } from 'Components/Clients/ClientView/ClientViewWrapper'
import { PageTitle } from 'Components/PageTitle/index'
import { SectionLabel } from 'Components/Section/SectionLabel/index'
import { SectionTitle } from 'Components/Section/SectionTitle/index'
import { SectionWrapper } from 'Components/Section/SectionWrapper/index'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import StyledIconButton from 'Components/Form/StyledIconButton'
import ClientsIcon from 'Assets/Images/icons/clients'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { PATHS } from 'Config/Routing/paths'
import CampaignsBlock from './CampaignsBlock'
import { getClientById } from './gql'
import { styles } from './styles'

const BreadcrumbsClientView = ({ name, currentPath }) => (
  <div>
    <Breadcrumbs icon={<ClientsIcon style={{ width: 24 }} />} />
    <Breadcrumb
      data={{
        title: 'Clients',
        pathname: `${PATHS.main.dashboard}${PATHS.dashboard.clients}`,
      }}
    />
    <Breadcrumb
      data={{
        title: name,
        pathname: currentPath,
      }}
    />
  </div>
)

const ClientView = ({ classes }) => {
  const match = useRouteMatch()
  const [client, setClient] = useState({})
  const clientId = match.params.id

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getClientById,
    defaultFetchArgs: clientId,
    mapResponse: data => data.clients.nodes[0],
  })

  useEffect(() => {
    if (isLoaded) {
      setClient(data)
    }
  }, [isLoaded])

  const sections = [
    {
      name: 'Name',
      value: <div>{client.name}</div>,
    },
    {
      name: 'Client Reference',
      value: <div>{client.code}</div>,
    },
    {
      name: 'Client Status',
      value: (
        <div>{client.status === 'DELETED' ? 'ARCHIVED' : client.status}</div>
      ),
    },
    {
      name: 'Client Tags',
      value: (
        <div>
          {client.tags && client.tags.length !== 0
            ? client.tags.map(tag => (
                <div className={classes.item}>{tag.value}</div>
              ))
            : 'No tags assigned'}
        </div>
      ),
    },
  ]

  return (
    <LayoutDashboard>
      <HideWhenBlocked>
        <ClientViewWrapper>
          <BreadcrumbsClientView currentPath={match.url} name={client.name} />
          <PageTitle className="page-title">
            {client.name || '\u00A0'}
            <Link
              to={`${PATHS.main.dashboard}${
                PATHS.dashboard.clients
              }/${clientId}/edit`}
              className="link-edit"
            >
              <StyledIconButton>
                <EditIcon />
              </StyledIconButton>
            </Link>
          </PageTitle>
          <SectionWrapper className="section-wrapper first">
            <SectionTitle className="section-title">
              Client Details
            </SectionTitle>
            <Row xs={12}>
              {isLoaded ? (
                sections.map(section => (
                  <Col key={section.name} xs={3}>
                    <SectionLabel className="section-label">
                      {section.name}
                    </SectionLabel>
                    {section.value}
                  </Col>
                ))
              ) : (
                <LoadingIndicator />
              )}
            </Row>
          </SectionWrapper>
          <CampaignsBlock client={client} />
        </ClientViewWrapper>
      </HideWhenBlocked>
    </LayoutDashboard>
  )
}

export default injectStyles(styles)(ClientView)



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientView/index.js